import React from 'react';

const CustomerComplaintComponentLoadable = React.lazy(() => import('./CustomerComplaintComponent'));
const AddCustomerComplaintComponentLoadable = React.lazy(() => import('./AddCustomerComplaintComponent'));
const CustomerComplaintDetailsComponentLoadable = React.lazy(() => import('./CustomerComplaintDetailsComponent'));

export {
    CustomerComplaintComponentLoadable, 
    AddCustomerComplaintComponentLoadable,
    CustomerComplaintDetailsComponentLoadable
};
